import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  contactType!: Observable<string>;
  contactTypeBS!: BehaviorSubject<string>;

  contactAction!: Observable<string>;
  contactActionBS!: BehaviorSubject<string>;

  contactDetails!: Observable<any>;
  contactDetailsBS!: BehaviorSubject<any>;

  baseUrl: string = environment.baseUrl;

  constructor(
    private http: HttpClient
  ) {
    this.contactTypeBS = <BehaviorSubject<string>>new BehaviorSubject('');
    this.contactType = this.contactTypeBS.asObservable();
    this.contactActionBS = <BehaviorSubject<string>>new BehaviorSubject('');
    this.contactAction = this.contactActionBS.asObservable();
    this.contactDetailsBS = <BehaviorSubject<any>>new BehaviorSubject(null);
    this.contactDetails = this.contactDetailsBS.asObservable();
  }

  updateContactType(type: string) {
    this.contactTypeBS.next(type);
  }

  updateContactAction(type: string) {
    this.contactActionBS.next(type);
  }

  updateContactDetails(details: {}) {
    this.contactDetailsBS.next(details);
  }

  addUpdateSecondaryContact(body: any) {
    return this.http.post(this.baseUrl + 'Profile/User/UpdateSecondaryMobileNumberRequest', body);
  }

  addUpdateEmergenctContact(body: any) {
    return this.http.post(this.baseUrl + 'Profile/Onboarding/SaveSecondaryEmergencyContactDetails', body);
  }

  addUpdateAddress(body: any) {
    return this.http.post(this.baseUrl + 'Profile/Onboarding/SaveSecondaryAddressDetails', body);
  }

  getRelationship() {
    return this.http.get(this.baseUrl + 'ListOfValues/GetRelationshipList');
  }

  getContactDetails() {
    return this.http.get(this.baseUrl + 'Profile/Onboarding/GetPersonalProfileDetails');
  }

  getStateList() {
    return this.http.get(this.baseUrl + 'ListOfValues/GetStateListByCountryCode?isoCode=MYS');
  }

  deleteContactDetails(body: any) {
    return this.http.post(this.baseUrl + 'Profile/Onboarding/RemoveDetailsByType', body);
  }
}
